import { html, SYSAction, SYSState, SYSTableDefIds } from "../../../../../src"
import { SortGet } from "../../../../../src/global/globalapi"
import {
  HookFieldGetList_ReturnType,
  HookFieldGetList_Type,
  HookFieldGetValueRender_ReturnType,
  HookFieldGetValueRender_Type,
  HookFormAdd_Type,
  HookFormChanged_Type,
  HookFormInit_ReturnType,
  HookFormInit_Type,
  HookFormValidate_Type,
  HookTableAfterDelete_Type,
  HookTableAfterSave_Type,
  HookTableBeforeSave_ReturnType,
  HookTableBeforeSave_Type,
  HookTableClicked_Type,
  HookTableCustomSort_ReturnType,
  HookTableCustomSort_Type,
  HookTableFn,
  HookTableFn_Type,
  HookTableRowFnCan_Type,
  HookTableSetColumnVisibility_Type,
} from "../../../../../src/global/hooks"
import {
  FieldList,
  FieldSetFocus,
  FieldSetState,
  FieldSetVal,
  FieldVal,
  SYSField,
} from "../../../../../src/library/forms/fieldapi"
import {
  FormGet,
  FormSetUnDirty,
  SYSFormState,
} from "../../../../../src/library/forms/formapi"
import {
  _GetFilterSortDifferentiator,
  GetRowDisplayValue,
} from "../../../../../src/library/table/helpers"
import {
  TableCellVal,
  TableGet,
  TableRebuild,
} from "../../../../../src/library/table/tableapi"
import { filterSortStore } from "../../../../offlinestorage"
import { T } from "../../../../textapi"

import {
  _BaseTableContextForColumnFilter,
  _SetFilter,
} from "./columnfilter/helpers"
import { SYSTableSettings_ColumnFilter } from "./columnfilter/tabledef"
import {
  SYSTableSettings_FilterSort,
  SYSTableSettings_FilterSortSelect,
} from "./filtersort/tabledef"
import { _HeaderMenuFilter_Type } from "./formdef"
import {
  _GetFilterSettingsCardCodes,
  _GetFilterSettingsCntctCodes,
  _GetFilterSortPermission,
} from "./helpers"

const HookTableBeforeSave: SYSAction<
  HookTableBeforeSave_Type,
  HookTableBeforeSave_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  if (value.formState.tableDefId.startsWith("SYSTableSettings_FilterSort")) {
    let settingsToSave =
      state.ovl.libState.tableSettings.filterSort.currentFilterSortSettings
    if (settingsToSave) {
      value.changedFields["U_FilterSortSettings"] = settingsToSave
    }
    let differentiator = _GetFilterSortDifferentiator(
      <SYSTableDefIds>(
        state.ovl.libState.tableSettings.filterSort.currentTableDefId
      )
    )
    value.changedFields["U_Differentiator"] = differentiator
  }
  return { resolve: "ForceSaveAndContinue" }
}

const HookTableAfterDelete: SYSAction<
  HookTableAfterDelete_Type<SYSTableSettings_ColumnFilter>
> = async (value, { global }) => {
  let state = global.getState()
  let filterSort = state.ovl.libState.tableSettings.filterSort
  let table = TableGet(<SYSTableDefIds>filterSort.currentTableDefId)
  if (value.deletedRow.Code === table.def.uiState.currentSelectedFilterSort) {
    let formState = FormGet("SYSHeaderMenuFilter", {
      instance: filterSort.fieldToUpdate.formId,
    })
    FieldSetVal(formState.fields["HeaderMenuSelectPersistedFilterSort"], "")
  }
}

const HookTableAfterSave: SYSAction<HookTableAfterSave_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()
  if (value.formState.tableDefId === "SYSTableSettings_FilterSort") {
    let filterSort = state.ovl.libState.tableSettings.filterSort

    // we also need to update the selected filtersettings value as persisted in indexed db
    let table = TableGet(<SYSTableDefIds>filterSort.currentTableDefId)
    table.def.uiState.currentSelectedFilterSortValue =
      filterSort.currentFilterSortSettings
    let differentiator = _GetFilterSortDifferentiator(table.def.id)

    table.def.uiState.currentSelectedFilterSortDesc =
      value.res.data[0]["U_Desc"]
    let valToUpdate = await filterSortStore.get(
      `${state.ovl.user.userCode.toString()}_${table.def.id}_${differentiator}`
    )
    if (valToUpdate) {
      valToUpdate.selectedValue = filterSort.currentFilterSortSettings
      valToUpdate.selectedDesc = table.def.uiState.currentSelectedFilterSortDesc
      await filterSortStore.set(
        `${state.ovl.user.userCode.toString()}_${
          table.def.id
        }_${differentiator}`,
        valToUpdate
      )
    }
    let formState = FormGet("SYSHeaderMenuFilter", {
      instance: filterSort.fieldToUpdate.formId,
    })
    await FieldSetVal(
      formState.fields["HeaderMenuSelectPersistedFilterSort"],
      value.res.data[0]["Code"] /*, {debounce:100}*/
    )
  }
}

const HookField_Code_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type<SYSTableSettings_ColumnFilter>,
  HookFieldGetValueRender_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  InitBaseTable(state)
  let val
  // if (_BaseTableContextForColumnFilter.isCalculated) {
  //   val = value.row["Code"]
  //   if (val === undefined) {
  //     val = null
  //   }
  // } else {
  val = GetRowDisplayValue(
    _BaseTableContextForColumnFilter.tableDef,
    _BaseTableContextForColumnFilter.columnKey,
    _BaseTableContextForColumnFilter.rows[value.row.Key],
    value.row.Key,
    "ColumnFilter",
    true
  )
  //}
  let resHtml
  if (typeof val === "string" || val === null) {
    resHtml = html`<a
      href="#"
      class="fd-link fd-link--emphasized ovl-hook-handled"
      tabindex="0"
    >
      <span class="fd-link__content">
        ${val === ""
          ? T("SYSFilterEmpty")
          : val === null
          ? T("SYSFilterNull")
          : val}
      </span>
    </a>`
  } else {
    resHtml = html`<div
      class="ovl-cursor-pointer __columnfilterhtmlval ovl-hook-handled"
    >
      ${val}
    </div>`
  }

  return {
    res: resHtml,
    valueRaw: _BaseTableContextForColumnFilter.isList ? val : value.row.Code,
  }
}

const HookField_Free1_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type<SYSTableSettings_ColumnFilter>,
  HookFieldGetValueRender_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  InitBaseTable(state)
  let val = GetRowDisplayValue(
    _BaseTableContextForColumnFilter.tableDef,
    _BaseTableContextForColumnFilter.additionalColumnKey,
    _BaseTableContextForColumnFilter.rows[value.row.Key],
    value.row.Key,
    "ColumnFilter",
    true
  )

  return {
    res: val,
    valueRaw: value.row.Free1,
  }
}

const InitBaseTable = (state: SYSState) => {
  if (!_BaseTableContextForColumnFilter.tableDef) {
    let baseTable = TableGet(
      state.ovl.libState.tableSettings.columnFilter.defId
    )
    _BaseTableContextForColumnFilter.tableDef = baseTable.def
    _BaseTableContextForColumnFilter.rows = baseTable.rows
    _BaseTableContextForColumnFilter.columnKey =
      state.ovl.libState.tableSettings.columnFilter.columnKey
    _BaseTableContextForColumnFilter.additionalColumnKey =
      state.ovl.libState.tableSettings.columnFilter.additionalColumnKey

    _BaseTableContextForColumnFilter.isList =
      _BaseTableContextForColumnFilter.tableDef.columns[
        _BaseTableContextForColumnFilter.columnKey
      ].list !== undefined

    _BaseTableContextForColumnFilter.isCalculated =
      _BaseTableContextForColumnFilter.tableDef.columns[
        _BaseTableContextForColumnFilter.columnKey
      ].schema?.isCalculatedColumn === true
  }
}

const HookTableClicked: SYSAction<HookTableClicked_Type> = async (value) => {
  if (
    value.rowKey &&
    value.columnKey === "Code" &&
    value.linkType === "OvlHook"
  ) {
    let row = TableGet<SYSTableSettings_ColumnFilter>(value.defId).rows[
      value.rowKey
    ]
    //Link was clicked
    await _SetFilter(false, row["Code"])
    value.executionToSet.selectionLogic = "Ignore"
  }
}

const HookTableCustom_OriginalSort_Sort: SYSAction<
  HookTableCustomSort_Type<SYSTableSettings_ColumnFilter>,
  HookTableCustomSort_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  return value.data[value.a].OriginalSort - value.data[value.b].OriginalSort
}

const HookField_HeaderMenuRangeFilterType_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  return {
    data: {
      equal: { Val: "equal", Desc: "=" },
      greaterThanOrEqual: {
        Val: "greaterThanOrEqual",
        Desc: ">=",
      },
      lessThanOrEqual: {
        Val: "lessThanOrEqual",
        Desc: "<=",
      },
    },
    lookupDef: {
      Val: { type: "text" },
      Desc: { type: "text" },
    },
  }
}

const HookFormValidate: SYSAction<HookFormValidate_Type> = async (
  value,
  { global }
) => {
  let actions = global.getActions()
  if (value.formState.formType === "SYSHeaderMenuFilter") {
    if (
      value.fieldKey === "HeaderMenuRangeFilterValue" ||
      value.fieldKey === "HeaderMenuRangeFilterType"
    ) {
      if (
        value.fieldKey === "HeaderMenuRangeFilterValue" &&
        FieldVal(value.formState.fields["HeaderMenuRangeFilterType"]) !== "none"
      ) {
        value.validatorUse("Mandatory", {
          validation: { displayType: "OnlyOutline" },
        })
      }
    }

    if (
      FieldVal(value.formState.fields["HeaderMenuRangeFilterType"]) ===
      "greaterThanOrEqual"
    ) {
      let val = FieldVal(value.formState.fields["HeaderMenuRangeFilterValue"], {
        mode: "Converted",
      })
      let val2 = FieldVal(
        value.formState.fields["HeaderMenuRangeFilterValue2"],
        {
          mode: "Converted",
        }
      )

      let cond = !val2 || val <= val2
      //console.log(val, val2, cond)
      if (!cond) {
        value.validationsAdd("SYSValidatorValue2SmallerThanValue1", {
          fields: [
            value.formState.fields["HeaderMenuRangeFilterValue2"],
            value.formState.fields["HeaderMenuRangeFilterValue"],
          ],
        })
      }
    }
  } else if (
    value.formState.tableDefId.startsWith("SYSTableSettings_FilterSort")
  ) {
    // if CanBeUsedBy === User then a user needs to be selected
    if (value.fieldKey === "U_CntctCode" || value.fieldKey === "CanBeUsedBy") {
      if (FieldVal(value.fields["CanBeUsedBy"]) === "@@SYSUser") {
        value.validatorUse("Mandatory", { field: value.fields["U_CntctCode"] })
      }
    }
  }
  // call parents formValidate Hook
  // so user can make additional Validation for Range Filter Fields
  let tableDef = TableGet(value.formState.tableDefId)
  let feature = tableDef.def.feature
  if (feature !== value.formState.feature) {
    if (actions.app.features?.[feature]?.hooks?.["HookFormValidate"]) {
      await actions.app.features[tableDef.def.feature].hooks[
        "HookFormValidate"
      ](value)
    }
  }
}

const HookTableSetColumnVisibility: SYSAction<
  HookTableSetColumnVisibility_Type<SYSTableSettings_FilterSort>
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  if (value.def.id.startsWith("SYSTableSettings_FilterSort")) {
    let p = _GetFilterSortPermission(
      state.ovl.libState.tableSettings.filterSort.currentTableDefId
    )
    if (!(p.modifyLevel === "company" || p.modifyLevel === "all")) {
      value.columnsVisibilityToSet.U_CntctCode = "Edit"
    }
  }
}

const HookFormChanged: SYSAction<HookFormChanged_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()
  let actions = global.getActions()
  if (value.formState.formType === "SYSHeaderMenuFilter") {
    if (
      value.changedField.field.fieldKey === "HeaderMenuRangeFilterType" &&
      value.changedField.validValueChanged &&
      !value.changedField.fromInit
    ) {
      FieldSetFocus(value.fields["HeaderMenuRangeFilterValue"])
    }
    HeaderMenuFilterFieldsSetState(value.formState)
    if (value.changedField && value.changedField.validValueChanged) {
      let tableDef
      if (value.formState.formId === "1") {
        tableDef = TableGet(state.ovl.libState.tableRowHeaderMenu.tableDefId1)
      } else {
        tableDef = TableGet(state.ovl.libState.tableRowHeaderMenu.tableDefId2)
      }

      if (
        value.changedField.field.fieldKey ===
        "HeaderMenuSelectPersistedFilterSort"
      ) {
        let def = tableDef.def
        let currentColumn = def.uiState.headerSelected
        let key =
          value.formState.fields["HeaderMenuSelectPersistedFilterSort"]
            .convertedValue
        await actions.ovl.internal._TableSelectFilterSort({
          key,
          defId: def.id,
          instance: value.formState.formId,
        })
        let colDef = def.uiState.filter.columns[currentColumn]
        if (colDef.rangeFilter) {
          await FieldSetVal(
            value.formState.fields["HeaderMenuRangeFilterType"],
            colDef.rangeFilter.selected
          )
          await FieldSetVal(
            value.formState.fields["HeaderMenuRangeFilterValue"],
            colDef.rangeFilter.val
          )

          await FieldSetVal(
            value.formState.fields["HeaderMenuRangeFilterValue2"],
            colDef.rangeFilter.val2
          )
        }
        FormSetUnDirty(value.formState)
        //HeaderMenuFilterFieldsSetState(value.formState)
      } else {
      }
    }
  } else if (
    value.formState.tableDefId.startsWith("SYSTableSettings_FilterSort")
  ) {
    if (value.changedField.fieldKey === "CanBeUsedBy") {
      FieldSetState(
        value.fields["U_CntctCode"],
        value.changedField.newValue === "@@SYSUser",
        { forceValueWhenInactive: null }
      )
      if (
        value.changedField.isValid &&
        value.changedField.newValue === "@@SYSUser" &&
        FieldVal(value.fields["U_CntctCode"]) === null
      ) {
        await FieldSetVal(value.fields["U_CntctCode"], state.ovl.user.userCode)
      }
    }
  }
}
export const HeaderMenuFilterFieldsSetState = (formState: SYSFormState) => {
  if (formState === undefined) {
    return
  }
  let filterType = FieldVal(formState.fields["HeaderMenuRangeFilterType"], {
    mode: "Converted",
  })
  let tableDef = TableGet(formState.tableDefId)
  let def = tableDef.def
  let selectedColumn = def.uiState.headerSelected
  if (!selectedColumn) {
    return
  }

  if (!def.columns[selectedColumn].filter.rangeFilter) {
    return
  }

  FieldSetState(
    formState.fields["HeaderMenuRangeFilterValue"],
    filterType !== "none" ||
      (def.columns[selectedColumn].filter.rangeFilter.defaultFilterType &&
        filterType === "none") /*&&
      isValidColumnFilterForRange,*/,
    {
      mode: "visible/notvisible",
      forceValueWhenInactive: null,
    }
  )
  FieldSetState(
    formState.fields["HeaderMenuRangeFilterValue2"],
    filterType === "greaterThanOrEqual" ||
      (def.columns[selectedColumn].filter.rangeFilter.defaultFilterType ===
        "greaterThanOrEqual" &&
        filterType === "none") /*&&
      isValidColumnFilterForRange,*/,
    {
      mode: "visible/notvisible",
      forceValueWhenInactive: null,
    }
  )
}

const HookFormAdd: SYSAction<HookFormAdd_Type> = (value, { global }) => {
  let state = global.getState()
  if (value.tableDef.id === "SYSTableSettings_FilterSort") {
    value.newRow["CanBeUsedBy"] = "@@SYSUser"
    value.newRow["U_CntctCode"] = state.ovl.user.userCode
  }
}

const HookFormInit: SYSAction<
  HookFormInit_Type,
  Promise<HookFormInit_ReturnType>
> = async (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let toRemove: string[] = []
  if (value.formState.formType === "SYSHeaderMenuFilter") {
    let tableDef = TableGet(
      state.ovl.libState.tableRowHeaderMenu[
        `tableDefId${value.formState.formId}`
      ]
    )
    let def = tableDef.def

    let p = _GetFilterSortPermission(def.id)
    let selectedColumn = def.uiState.headerSelected
    let fields: { [key in keyof _HeaderMenuFilter_Type]: SYSField } =
      value.formState.fields

    if (!def.columns[selectedColumn].filter.rangeFilter) {
      toRemove.push(fields.HeaderMenuRangeFilterValue.fieldKey)
      toRemove.push(fields.HeaderMenuRangeFilterValue2.fieldKey)
      toRemove.push(fields.HeaderMenuRangeFilterType.fieldKey)
    }
    if (!p.found) {
      //console.log("set headermenuselectfilter irrelevenat in init")
      toRemove.push(fields.HeaderMenuSelectPersistedFilterSort.fieldKey)
    }
  } else if (
    value.formState.tableDefId.startsWith("SYSTableSettings_FilterSort")
  ) {
    let p = _GetFilterSortPermission(value.formState.row["U_TableDefId"])

    let fields: { [key in keyof SYSTableSettings_FilterSort]: SYSField } =
      value.formState.fields

    if (!(p.modifyLevel === "company" || p.modifyLevel === "all")) {
      toRemove.push(fields.CanBeUsedBy.fieldKey)
    } else {
      await _GetFilterSettingsCardCodes()
    }
    if (
      !(p.modifyLevel === "company" || p.modifyLevel === "all") //||
      // FieldVal(value.formState.fields["CanBeUsedBy"]) !== "@@SYSUser"
    ) {
      toRemove.push(fields.U_CntctCode.fieldKey)
    } else {
      await _GetFilterSettingsCntctCodes()
    }
    // if (value.formState.tableDataMode === "Add") {
    //   FieldSetVal(value.formState.fields["CanBeUsedBy"], "@@SYSUser")
    // }
  }
  return { fieldsToRemove: toRemove }
}

const HookField_HeaderMenuSelectPersistedFilterSort_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let baseTable = TableGet(
    <SYSTableDefIds>(
      state.ovl.libState.tableSettings.filterSort.currentTableDefId
    )
  )
  let differentiator = baseTable.def.uiState._lastFilterSortDifferentiator
  let table = TableGet("SYSTableSettings_FilterSort")

  let p = _GetFilterSortPermission(value.formState.tableDefId)
  let presetAll
  let presetCompany
  if (!(p.readLevel === "all" || p.readLevel === "company")) {
    presetAll = T("SYSFilterSortPresetAll")
    presetCompany = T("SYSFilterSortPresetCompany")
  }
  let rows: {
    [key: string]: { [key in keyof SYSTableSettings_FilterSortSelect]: any }
  } = table.rows

  let keys
  // if (value.needsFullList) {
  keys = table.getKeys({ byKeys: "StaticFiltered" })
  // .filter(
  //   (f) =>
  //     differentiator === undefined ||
  //     table.rows[f].U_Differentiator === differentiator
  // )

  // } else {
  // keys = table.getKeys({
  //   byIdValue:
  //     value.formState.fields["HeaderMenuSelectPersistedFilterSort"]
  //       .convertedValue,
  // })
  //}

  let userCode = state.ovl.user.userCode
  let userCompanyName = state.ovl.user.cardName
  keys = keys.sort((s1, s2) => {
    let a = table.rows[s1]
    let b = table.rows[s2]
    //1st all own
    let ownA = a.CanBeUsedBy === "@@SYSUser" && a.U_CntctCode === userCode
    let ownB = b.CanBeUsedBy === "@@SYSUser" && b.U_CntctCode === userCode
    let res = SortGet(ownB, ownA)
    if (res === 0) {
      res = SortGet(a.CanBeUsedBy === "@@SYSAll", b.CanBeUsedBy === "@@SYSAll")

      if (res === 0) {
        //then all from the same company
        ownA =
          a.CardName === userCompanyName ||
          a.UserCompanyName === userCompanyName
        ownB =
          b.CardName === userCompanyName ||
          b.UserCompanyName === userCompanyName
        res = SortGet(ownB, ownA)
        if (res === 0) {
          // then by companyname
          let valA = `${
            a.UserCompanyName ? a.UserCompanyName : a.CardName ? a.CardName : ""
          }`
          let valB = `${
            b.UserCompanyName ? b.UserCompanyName : b.CardName ? b.CardName : ""
          }`
          res = SortGet(valA, valB)
          if (res === 0) {
            // then  by description
            res = SortGet(a.U_Desc, b.U_Desc)
          }
        }
      }
    }

    return res
  })

  let data = keys.reduce(
    (val, m, i) => {
      let Desc = ""
      switch (rows[m].CanBeUsedBy) {
        case "@@SYSUser":
          if (rows[m].UserCompanyName && rows[m].U_CntctCode !== userCode) {
            Desc = `${rows[m].UserCompanyName}${T(
              "SYSFilterSortCompanyUserDelimiter"
            )}${rows[m].UserName}${T("SYSFilterSortSetDelimiter")}${
              rows[m].U_Desc
            }`
          } else {
            Desc = `${T("SYSFilterSortSetOwn")}${T(
              "SYSFilterSortSetDelimiter"
            )}${rows[m].U_Desc}`
          }
          break
        case "@@SYSAll":
          Desc = `${presetAll ? presetAll : T("SYSFilterSortSetAll")}${T(
            "SYSFilterSortSetDelimiter"
          )}${rows[m].U_Desc}`
          break
        default:
          Desc = `${presetCompany ? presetCompany : rows[m].CardName}${T(
            "SYSFilterSortSetDelimiter"
          )}${rows[m].U_Desc}`

          break
      }

      let d = { Val: rows[m].Code, Desc }
      val[rows[m].Code] = d
      return val
    },
    { "": { Val: "", Desc: T("SYSFilterSortSetDefault") } }
  )

  return <HookFieldGetList_ReturnType>{
    data,
    lookupDef: {
      Desc: { translationKey: "SYSTableSettingsFilterSelect", type: "text" },
    },
  }
}
const HookField_CanBeUsedBy_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let p = _GetFilterSortPermission(
    state.ovl.libState.tableSettings.filterSort.currentTableDefId
  )
  let data = {}
  data["@@SYSUser"] = { Desc: T("SYSLoginUser") }
  if (!value.formState || p?.modifyLevel === "all") {
    data["@@SYSAll"] = { Desc: T("SYSFilterAll") }
  }
  let lookups = state.ovl.libState.tableSettings.filterSort.lookups.CardCode
  if (lookups && lookups.length > 0) {
    data = lookups.reduce((val, l) => {
      val[l.CardCode] = { Desc: l.CardName }
      return val
    }, data)
  }
  return {
    data,
  }
}

const HookField_U_CntctCode_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let lookups = state.ovl.libState.tableSettings.filterSort.lookups.U_CntctCode
  let data = {}
  if (lookups && lookups.length > 0) {
    data = lookups.reduce((val, l) => {
      val[l.CntctCode] = { Val: l.CntctCode, Desc: l.Name }
      return val
    }, data)
  }
  return {
    data,
    sortFn: (a, b) => SortGet(a.Desc, b.Desc),
  }
}

const HookField_U_CntctCode_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type<SYSTableSettings_FilterSort>,
  HookFieldGetValueRender_ReturnType
> = (value) => {
  let val = "---"
  if (value.row.CanBeUsedBy === "@@SYSUser") {
    val = TableCellVal(value.tableDef.id, value.rowKey, value.columnKey, {
      useDisplayValue: true,
    })
  }
  return {
    res: val,
  }
}

const HookTableRowFnCan: SYSAction<
  HookTableRowFnCan_Type<SYSTableSettings_FilterSort>
> = async (value, { global }) => {
  let state = global.getState()
  if (value.tableDef.id === "SYSTableSettings_ColumnFilter") {
    return
  }

  let p = _GetFilterSortPermission(
    state.ovl.libState.tableSettings.filterSort.currentTableDefId
  )

  if (!p.modifyLevel) {
    value.set(["OvlEdit", "OvlDelete"], { visibility: "Disabled" })
    return
  }

  let isValid = value.row.U_CntctCode === state.ovl.user.userCode
  if (!isValid) {
    isValid = (p.modifyLevel === "company" || p.modifyLevel === "all") && value.row.CanBeUsedBy === state.ovl.user.cardCode
  }
  if (!isValid) {
    isValid = p.modifyLevel === "all" && value.row.CanBeUsedBy === "@@SYSAll"
  }
  if (!isValid) {
    isValid =
      ((p.modifyLevel as string) === "all") ||
      (((p.modifyLevel as string) === "company" || (p.modifyLevel as string) === "all") && value.row.CanBeUsedBy === "@@SYSUser")
  }
  if (!isValid) {
    value.set(["OvlEdit", "OvlDelete"], { visibility: "Disabled" })
  }
}

export let hooks = {
  HookTableBeforeSave,
  HookTableAfterDelete,
  HookTableAfterSave,
  HookField_Code_GetValueRender,
  HookField_Free1_GetValueRender,
  HookTableClicked,
  HookTableCustom_OriginalSort_Sort,
  HookField_HeaderMenuRangeFilterType_GetList,
  HookFormValidate,
  HookTableSetColumnVisibility,
  HookFormChanged,
  HookFormAdd,
  HookFormInit,
  HookField_HeaderMenuSelectPersistedFilterSort_GetList,
  HookField_CanBeUsedBy_GetList,
  HookField_U_CntctCode_GetList,
  HookField_U_CntctCode_GetValueRender,
  HookTableRowFnCan,
}
